
import { Vue, Component, Prop } from "vue-property-decorator"
import api from "../honcierge-api"
import { mapState, mapActions } from "vuex"
import { Category, SubCategory, ID, ArticleCategory } from "types/index"

type SubCategoryType = Pick<SubCategory["data"], "id" | "name" | "category">

@Component({
  computed: {
    ...mapState("article", [
      "categories",
      "mainCategoryId",
      "mainSubCategory",
      "subCategories",
    ]),
    selectedCategorySize(): number {
      if (this.$store.state.article && this.$store.state.article.categories) {
        return this.$store.state.article.categories.length
      }
      return 0
    },
    mainCategory: {
      get() {
        return this.$store.state.article.mainCategoryId
      },
      set(mainCategoryId) {
        this.$store.dispatch("article/updateMainCategoryId", {
          mainCategoryId,
        })
      },
    },
  },
  methods: {
    ...mapActions("article", [
      "removeCategory",
      "addCategory",
      "updateMainCategoryId",
      "updateMainSubCategory",
      "updateSubCategories",
    ]),
  },
})
export default class Categories extends Vue {
  @Prop()
  private articleId!: number

  @Prop()
  private readonly!: boolean

  private mainCategoryId!: number
  private mainCategory!: Category["view"]
  private mainSubCategory!: SubCategory["data"]
  private categories!: Category["view"][]
  private subCategories!: SubCategoryType[]

  private removeCategory!: (o: { category: Category["view"] }) => void
  private addCategory!: (o: { category: Category["view"] }) => void
  private updateMainCategoryId!: (o: { mainCategoryId: null }) => void
  private updateMainSubCategory!: (o: { mainSubCategory: null }) => void
  private updateSubCategories!: (o: {
    subCategories: SubCategoryType[]
  }) => void

  private masterCategories: ArticleCategory[] = []
  private masterSubCategories: SubCategoryType[] = []

  // checkbox用
  private selectedMap: Map<ID, boolean> = new Map()

  private created() {
    this.setMasterCategories()
  }

  private toggleSelect(selectCategory: Category["view"]) {
    const target = this.categories.find(
      (category) => category.id === selectCategory.id
    )

    // categoriesにあれば削除, なければ追加
    if (target) {
      this.removeCategory({ category: target })
      this.selectedMap.set(target.id, false)

      // 削除されるカテゴリーを持っているパンくず大カテゴリーを消すようにする
      if (this.mainCategoryId === target.id) {
        this.removeMainCategory()
      }

      // 削除されるカテゴリーを持っているパンくず小カテゴリーを消すようにする
      if (this.mainSubCategory) {
        this.removeMainSubCategoriesByCategory(target)
      }

      // 削除されるカテゴリーを持っている小カテゴリーを消すようにする
      if (this.subCategories) {
        this.removeSubCategoriesByCategory(target)
      }
    } else {
      this.addCategory({ category: selectCategory })
      this.selectedMap.set(selectCategory.id, true)
    }
  }

  private async setMasterCategories() {
    try {
      const response = await api.getCategories({
        search: "",
        page: 1,
        per: 100000, // カテゴリーは全取得するためにperは十分大きい値を渡す
        sortBy: "priority",
        descending: true,
        includeDisabled: true,
        fields: ["id", "name", "priority", "isEnabled"],
      })
      const categories: ArticleCategory[] = response.data.categories
      this.masterCategories = categories.filter((c) => c.isEnabled)
      this.masterCategories.forEach((masterCategory) => {
        const category = this.categories.find(
          (checkedCategory) => checkedCategory.id === masterCategory.id
        )
        this.selectedMap.set(masterCategory.id, category ? true : false)
      })
    } catch (error) {
      this.$toasted.error("カテゴリーの取得に失敗しました")
      this.$router.push("/")
    }
  }

  private removeMainCategory() {
    this.updateMainCategoryId({ mainCategoryId: null })
  }

  private removeMainSubCategoriesByCategory(category: Category["view"]) {
    if (this.mainSubCategory.category.id === category.id) {
      this.updateMainSubCategory({ mainSubCategory: null })
    }
  }

  private removeSubCategoriesByCategory(category: Category["view"]) {
    const subCategories = this.subCategories.filter((subCategory) => {
      return subCategory.category.id !== category.id
    })
    this.updateSubCategories({ subCategories })
  }
}
